var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6809 10.5914C14.394 10.7412 14.0409 10.6266 13.8928 10.3325H13.8928C12.9943 8.5465 10.609 5.9861 7.49997 5.9861C4.71173 5.9861 2.23389 8.09275 1.10719 10.3325C0.958976 10.6256 0.606008 10.7413 0.318459 10.5906C0.0309393 10.4399 -0.0828497 10.0806 0.0644257 9.78703C1.35894 7.20852 4.20568 4.79069 7.49997 4.79069C11.257 4.79069 13.9478 7.8196 14.9355 9.78703C15.083 10.0809 14.969 10.441 14.6809 10.5914ZM0.227668 4.17207L1.53267 5.37297C1.77437 5.59541 2.14474 5.57314 2.36022 5.32952C2.57695 5.0844 2.55791 4.70648 2.31762 4.48536L1.01262 3.28446C0.772414 3.0634 0.401926 3.08276 0.18507 3.32791C-0.0316681 3.57303 -0.0126251 3.95095 0.227668 4.17207ZM13.4672 5.37297L14.7722 4.17207C15.0125 3.95095 15.0316 3.57303 14.8148 3.32791C14.598 3.08282 14.2276 3.06334 13.9873 3.28446L12.6823 4.48536C12.442 4.70645 12.423 5.0844 12.6397 5.32952C12.8554 5.57341 13.2258 5.59514 13.4672 5.37297ZM7.49994 2.99012C7.82356 2.99012 8.08588 2.7225 8.08588 2.39242V0.597701C8.08588 0.267621 7.82356 0 7.49994 0C7.17633 0 6.914 0.267621 6.914 0.597701V2.39242C6.91403 2.72253 7.17636 2.99012 7.49994 2.99012ZM10.3784 10.0593C10.3784 11.6808 9.0871 13 7.49997 13C5.91284 13 4.62158 11.6808 4.62158 10.0593C4.62158 8.43787 5.91284 7.11868 7.49997 7.11868C9.0871 7.11868 10.3784 8.43787 10.3784 10.0593ZM9.20651 10.0593C9.20651 9.09701 8.44099 8.31408 7.5 8.31408C6.55901 8.31408 5.79346 9.09701 5.79346 10.0593C5.79346 11.0217 6.55899 11.8046 7.49997 11.8046C8.44096 11.8046 9.20651 11.0217 9.20651 10.0593Z",
    fill: "#98A2B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3538,
    y: 2,
    width: 1.40134,
    height: 18.2548,
    rx: 0.700668,
    transform: "rotate(47.0142 15.3538 2)",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.96d3198576c82dbeb620c8c09222a8b0.svg";
export { ForwardRef as ReactComponent };